import React from 'react';
import './App.css';
import song1 from './assets/songs/1stuckinmyways.mp3';
import song2 from './assets/songs/2schrodinger_schat.mp3';
import song3 from './assets/songs/3bestfriend.mp3';
import song4 from './assets/songs/4CONNECTIONISSUES.mp3';
import song5 from './assets/songs/5brokentelephone.mp3';
import song6 from './assets/songs/6baddie.mp3';
import song7 from './assets/songs/7magic.mp3';
import song8 from './assets/songs/8THERE_SALOTTOUNPACK.mp3';
import song9 from './assets/songs/9codeinebaby.mp3';
import image1 from './assets/images/1StuckInMyWays.png';
import image2 from './assets/images/2Schrodinger_schat.png';
import image3 from './assets/images/3Bestfriend.png';
import image4 from './assets/images/4ConnectionIssue.png';
import image5 from './assets/images/5BrokenTelephone.png';
import image6 from './assets/images/6Baddie.png';
import image7 from './assets/images/7magic.png';
import image8 from './assets/images/8theresalottounpack.png';
import image9 from './assets/images/9CodeineBaby.png';

import { AudioPlayer, ITrack } from './AudioPlayer';

const tracks: ITrack[] = [
  {
    title: 'stuck in my ways',
    artist: 'VI The Law',
    audioSrc: song1,
    image: image1,
    lyrics: "",
  },
  {
    title: 'schrodinger\'s chat',
    artist: 'VI The Law',
    audioSrc: song2,
    image: image2,
    lyrics: "",
  },
  {
    title: 'best friend',
    artist: 'VI The Law',
    audioSrc: song3,
    image: image3,
    lyrics: "",
  },
  {
    title: 'CONNECTION ISSUES',
    artist: 'VI The Law',
    audioSrc: song4,
    image: image4,
    lyrics: "",
  },
  {
    title: 'broken telephone',
    artist: 'VI The Law',
    audioSrc: song5,
    image: image5,
    lyrics: "",
  },
  {
    title: 'baddie',
    artist: 'VI The Law',
    audioSrc: song6,
    image: image6,
    lyrics: "",
  },
  {
    title: 'magic',
    artist: 'VI The Law',
    audioSrc: song7,
    image: image7,
    lyrics: "",
  },
  {
    title: 'THERE\'S A LOT TO UNPACK',
    artist: 'VI The Law',
    audioSrc: song8,
    image: image8,
    lyrics: "",
  },
  {
    title: 'codeine baby',
    artist: 'VI The Law',
    audioSrc: song9,
    image: image9,
    lyrics: "",
  }
];

function App() {
  return (
    <div className="App">
      <AudioPlayer tracks={tracks} />
    </div>
  );
}

export default App;
